module.exports = __webpack_public_path__ + "static/media/loading.58e997d9.gif";